<div class="app">
	<nav class="top">
		<div class="scene-container" [ngStyle]="{'height': sceneHeight}"
			(mousemove)="onMouseMove($event)" (mouseleave)="onMouseLeave()">
			<div class="scene-container-wrapper">
				<div class="circle-wrapper" (mousemove)="handleMouseMove($event)"
					(mouseleave)="handleMouseLeave()"
					[ngClass]="{'animate': animateCircle, 'reverse-animate': !animateCircle}"
					*ngIf="!showScene">
					<div class="circle"
						[ngClass]="{'animate': animateCircle, 'reverse-animate': !animateCircle}"></div>
				</div>
				<!-- cardboardModeEnabled:true; enabled:true; enterVRButton: #myEnterVRButton; enterARButton: #myEnterARButton;  XRMode: xr; enterARButton: enabled; enterVRButton: enabled; 		
					/*xr-mode-ui="cardboardModeEnabled:true; enabled:true; XRMode: xr; enterVREnabled: enabled; enterAREnabled: enabled; enterVRButton: #myEnterVRButton; enterARButton: #myEnterARButton;"*/
				-->
				<a-scene class="aframe-scene" [ngClass]="{'hovered': isHovered}"
					[ngStyle]="{'top': sceneTop}" embedded> <a-camera
					camera="active:true; far:10000; fov:40; near:0.005; spectator:true; zoom:40;"
					look-controls wasd-controls> <a-entity class="camera"
					position="0 0 0"> </a-entity></a-camera> <a-sky src="/img/_.png"
					rotation="0 -130 0"></a-sky> <a-text font="kelsonsans"
					value="Puy de Sancy, France" width="6" position="-2.5 0.25 -1.5"
					rotation="0 15 0"></a-text> <a id="myEnterVRButton" href="#">VR</a>
				<a id="myEnterARButton" href="#">AR</a> </a-scene>
			</div>
		</div>
		<div class="nav-wrapper mat-end blue-grey darken-4">
			<mat-toolbar [style.backgroundColor]="'transparent'"
				[style.z-index]="'99'" [style.position]="'relative'"
				[style.justify-content]="'flex-end'">

			<button mat-flat-button routerLink="/">
				<mat-icon>search</mat-icon>
				<span>world</span>
			</button>
			<button mat-flat-button routerLink="/registration">
				<mat-icon>chrome_reader_mode</mat-icon>
				<span>page</span>
			</button>
			<button mat-mini-fab  color="error" [matMenuTriggerFor]="menu" fxFlex="none"
				aria-label="Example icon-button with a menu">
				<mat-icon>pages</mat-icon>
			</button>
			<mat-menu #menu="matMenu"> <a mat-menu-item
				routerLink="/profile/avatarmaker"><mat-icon>view_day</mat-icon><span>Avatar</span></a>
			<a mat-menu-item routerLink="/profile/photobook"><mat-icon>landscape</mat-icon><span>Photo</span></a>
			<a mat-menu-item routerLink="/profile/audiobook"><mat-icon>blur_linear</mat-icon><span>Audio</span></a><!-- headset -->
			<a mat-menu-item routerLink="/auth/postauth"><mat-icon>face</mat-icon><span>Nick</span></a><!-- -->
			<a mat-menu-item routerLink="/stream/accounts"><mat-icon>movie</mat-icon><span>Stream</span></a>
			<a mat-menu-item routerLink="/video/"><mat-icon>movie_filter</mat-icon><span>Video</span></a>
			<a mat-menu-item routerLink="/profile/photostorage"><mat-icon>party_mode</mat-icon><span>Photo
					Storage</span></a> <a mat-menu-item routerLink="/discourse"><mat-icon>grain</mat-icon><span>Discourse</span></a>
			<a mat-menu-item routerLink="/profile"><mat-icon>3d_rotation</mat-icon><span>Shifts</span></a>
			<a mat-menu-item routerLink="/dockets"><mat-icon>dashboard</mat-icon><span>Dockets</span></a>
			<a mat-menu-item routerLink="/profile/accounts"><mat-icon>recent_actors</mat-icon><span>Accounts</span></a><!-- supervisor_account -->
			<a mat-menu-item routerLink="/application/confiditialpolicy"><mat-icon>aspect_ratio</mat-icon><span>Confidential
					Policy</span></a> <a mat-menu-item routerLink="/application/visitoragreements"><mat-icon>security</mat-icon><span>Visitor
					Agreements</span></a> </mat-menu><!--</ul>--></mat-toolbar>
		</div>
	</nav>
	<div class="content horizontal-scroll-container">
		<modal />
		<router-outlet />
	</div>
	<footer class="page-footer">

		<div class="right">
			<div class="col s12 teal-text text-lighten-4">
				<mat-list> 
					<mat-list-item><connection /></mat-list-item>
					<mat-list-item class="fix">
						<mat-icon matListItemIcon>widgets</mat-icon>
						<span class="fix"><a class="fix" href="https://neveru.me">neveru.me</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;alpha 2024&nbsp;&nbsp;&nbsp; 
						</span>
					</mat-list-item>
				</mat-list>



			</div>
		</div>
	</footer>
</div>

<!-- 
<footer class=" c page-footer grey boxx box-3">
	<div class="container ">
		<div class="row">
			<div class="col l6 s12">
				<h5 class="white-text">Footer Content</h5>
				<p class="grey-text text-lighten-4">Rows and columns are used to
					organize the footer content.</p>
			</div>
			<div class="col l4 offset-l2 s12">
				<h5 class="white-text">Links</h5>
				<ul>
					<li><a class="grey-text text-lighten-3" href="#!"> Link 1
					</a></li>
					<li><a class="grey-text text-lighten-3" href="#!"> Link 2
					</a></li>
					<li><a class="grey-text text-lighten-3" href="#!"> Link 3
					</a></li>
				</ul>
			</div>
		</div>
	</div>
	<div class="footer-copyright darken-3">
		<div class="container ">
			&copy;
			<?= date('Y') ?>
			<a href="https://getlaminas.org/">Laminas Project</a> a Series of LF
			Projects, LLC.
		</div>
	</div>
</footer> -->